import React from "react";
import MuiTextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";

export default function TextField({
  /* extra props */

  /* defaults for mui TextField's props */
  size = "small",
  variant = "outlined",
  fullWidth = true,
  ...other_props
}) {
  return (
    <MuiTextField
      {...{
        size, variant, fullWidth,
        ...other_props,
      }}
    />
  );
}

